import { AnimatePresence, motion } from "framer-motion";

export const SentToast = ({ sent }) => (
  <div className="pointer-events-none fixed inset-x-0 bottom-24 z-[60] flex justify-center px-4">
    <AnimatePresence>
      {sent && (
        <motion.div
          initial={{ opacity: 0, y: 16, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 10, scale: 0.95 }}
          transition={{ type: "spring", stiffness: 380, damping: 24 }}
          className="bg-nothing-red text-white font-mono text-xs px-4 py-2 rounded-full shadow-xl flex items-center gap-2"
        >
          TRANSMISSION_SENT <span className="animate-pulse">[OK]</span>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);